export const round = (value) => {
    if (!value) return "";
    if (value < 1) return value.toFixed(4);
    if (value < 100) return value.toFixed(2);
    return value.toFixed(0);
};